import axios from "axios";
import Vue from "vue";
import store from "../store/index";

const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const authToken = store.state.authToken;

    if (authToken) {
      config.headers["Authorization"] = `Bearer ${authToken}`;
    }

    const metodo = (config.method || "").toLowerCase();
    const revisoes = store.state.revisoesConfiguracao;
    if (
      ["post", "put", "patch", "delete"].includes(metodo) &&
      Object.keys(revisoes).length
    ) {
      config.headers["X-Revisoes-Configuracao"] = JSON.stringify(revisoes);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

function deveGuardarRevisao(response) {
  const config = response.config || {};
  const metodo = (config.method || "").toLowerCase();
  if (response.headers && response.headers["x-revisao-gravada"]) return true;
  if (metodo !== "get") return false;
  const url = (config.url || "").split("?")[0];
  return /^\/configuracao\/[^/]+$/.test(url);
}

function guardarRevisao(response) {
  const headers = response && response.headers;
  if (!headers || !deveGuardarRevisao(response)) return;
  const id = headers["x-configuracao"];
  const revisao = headers["x-revisao-configuracao"];
  if (id && revisao !== undefined) {
    store.commit("setRevisaoConfiguracao", {
      id,
      revisao: Number.isNaN(Number(revisao)) ? revisao : Number(revisao),
    });
  }
}

api.interceptors.response.use(
  function (response) {
    guardarRevisao(response);
    if (response.data && response.data.message) {
      Vue.$toast.success(response.data.message);
    }
    return response;
  },
  function (error) {
    if (
      error.response &&
      error.response.status === 409 &&
      error.response.data &&
      error.response.data.codigo === "conflito_revisao"
    ) {
      store.commit("setConflitoRevisao", {
        message: error.response.data.message,
      });
    } else if (
      error.response &&
      error.response.data &&
      error.response.data.message
    ) {
      Vue.$toast.error(error.response.data.message);
    } else if (error.message) {
      Vue.$toast.error(error.message);
    } else {
      Vue.$toast.error("Ocorreu um erro inesperado");
    }
    return Promise.reject(error);
  }
);

export default api;
